import RytmWebflow from 'rytm-webflow'
import { trace } from 'rytm-helpers'
import { WCAG } from "rytm-wcag"
import { windowUpdate, removeReCaptchaBadge } from './shared/common'
// controllers
import Controller from './controllers/Controller'
import SubstrateSidebraController from './controllers/SubstrateSidebraController'
import MapController from './controllers/MapController'
// views
import BasicView from './views/BasicView'
import ListView from './views/ListView'
import FullHeaderView from './views/FullHeaderView'
import { abordXhrRequests } from './shared/search'
import { scrollToOnPageChange } from './shared/scroll-to'

const routes = {
  'basic': {
    controller: Controller,
    view: BasicView
  },
  'list': {
    controller: Controller,
    view: ListView
  },
  'full_header': {
    controller: Controller,
    view: FullHeaderView
  },
  'map': {
    controller: MapController,
    view: BasicView
  },
  'substrate_sidebar': {
    controller: SubstrateSidebraController,
    view: BasicView
  },
}
const aswapProps = {
  animationTimeHide: 800,
  animationTimeShow: 800,
  preloadOnHover: false,
  cacheOn: true,
  formsEnabled: false,
  routes,
  trace,
}
const aswapEvents = {
  onViewSwapComplete: () => {
    WCAG.onViewChanged();
    windowUpdate();
    RytmWebflow.showUp.rebuild();
    setTimeout(scrollToOnPageChange, 100);
  },
  onViewHide: () => {
    WCAG.dialogCloseAll()
    removeReCaptchaBadge()
    RytmWebflow.showUp.hide()
    RytmWebflow.bootsrap5.hideFlyovers()
    abordXhrRequests()
  },
  onViewHidden: () => {
    // destroy...
  },
  onViewShown: () => {
    windowUpdate();
  }
}

export const initASwap = () => {
  RytmWebflow.aswap.init(aswapProps, aswapEvents)
}